import { render, staticRenderFns } from "./sheetListold.vue?vue&type=template&id=c053d45a&scoped=true&"
import script from "./sheetListold.vue?vue&type=script&lang=js&"
export * from "./sheetListold.vue?vue&type=script&lang=js&"
import style0 from "./sheetListold.vue?vue&type=style&index=0&id=c053d45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c053d45a",
  null
  
)

export default component.exports